import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Modal, Toast, PasswordInput } from "@/components/Layout";
import api from "@/lib/api";

export default function ForcePasswordChange() {
  const { user, refresh } = useAuth();
  const [oldPw, setOldPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const [conf, setConf] = useState("");
  const [msg, setMsg] = useState({text:"",type:"info"});

  if (!user || user === false || !user.must_change_password) return null;

  const submit = async () => {
    if (newPw !== conf) { setMsg({text:"Confirmarea parolei nu coincide",type:"error"}); return; }
    if (newPw.length < 12) { setMsg({text:"Parola nouă trebuie să aibă minim 12 caractere",type:"error"}); return; }
    try {
      await api.post("/auth/change-password", { old_password: oldPw, new_password: newPw });
      setMsg({text:"Parola a fost schimbată",type:"success"});
      await refresh();
    } catch(e) { setMsg({text:e?.response?.data?.detail||"Eroare",type:"error"}); }
  };

  return (
    <Modal title="Schimbă parola" onClose={()=>{}} width={440}>
      <div style={{fontSize:13,color:"#334155",marginBottom:16,background:"#FEF3C7",padding:"10px 12px",borderRadius:6}}>
        ⓘ Din motive de securitate, parola ta actuală e una temporară — trebuie să o schimbi cu una aleasă de tine înainte de a continua.
      </div>
      <Toast msg={msg.text} type={msg.type} />
      <div style={{display:"grid",gap:12}}>
        <div><label className="label label-req">Parola curentă</label>
          <PasswordInput value={oldPw} onChange={e=>setOldPw(e.target.value)} testId="pw-old" autoComplete="current-password" /></div>
        <div><label className="label label-req">Parolă nouă (minim 12 caractere, nu una des folosită)</label>
          <PasswordInput value={newPw} onChange={e=>setNewPw(e.target.value)} testId="pw-new" autoComplete="new-password" /></div>
        <div><label className="label label-req">Confirmă parola nouă</label>
          <PasswordInput value={conf} onChange={e=>setConf(e.target.value)} testId="pw-conf" autoComplete="new-password" /></div>
      </div>
      <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:18}}>
        <button className="btn btn-primary" onClick={submit} data-testid="pw-submit">Schimbă parola</button>
      </div>
    </Modal>
  );
}
